import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss',
})
export class LayoutComponent {
  slimMode = false;

  @Input() set isSlimMode(val: boolean) {
    this.slimMode = val;
  }
  @Input() hideSidebar: boolean = false;
  @Input() hideSubSideBar: boolean = false;
  @Output() isSlimModeChange = new EventEmitter<boolean>();

  constructor() {}

  ngOnInit(): void {}

  onSlimModeChange(value: boolean): void {
    this.slimMode = value;
    this.isSlimModeChange.emit(value);
  }
}
